import {FC, useEffect, useState} from "react";

const updateCountdown = (offerExpiresAt: string) => {
    const now = new Date();
    const expiresAt = new Date(offerExpiresAt);
    const timeDiff = expiresAt.getTime() - now.getTime();

    if (timeDiff <= 0) {
        return 'Offer Expired';
    } else {
        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        return `Offer Expires in ${hours}h ${minutes}m ${seconds}s`;
    }
};

const OfferTimer: FC<{expiresAt: string, setIsExpired?: (expired: boolean) => void}> = ({expiresAt, setIsExpired}) => {
    const [time, setTime] = useState<string>('')

    const updateTime = () => {
        const resString = updateCountdown(expiresAt)
        setTime(resString)
        setIsExpired && setIsExpired(resString === 'Offer Expired')
    }

    useEffect(() => {
        updateTime()
        setInterval(updateTime, 1000)
    }, []);

    return (
        <div>
            {time}
        </div>
    )
}

export default OfferTimer;
